import { CustomerOrder } from "@omni/types/api/cart/bff/customerOrder.model";
import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { Pagination } from "@/components/General/Pagination/pagination.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatISO } from "@/utils/date";
import { formatPrice } from "@/utils/price.utils";

import { CUSTOMER_ORDER_LIST_PAGE_SIZE } from "./hooks/useOrderList.hook";
import Order from "./Order/order.component";
import OrderSummary from "./OrderSummary/orderSummary.component";

type Props = {
    orders: Array<CustomerOrder>;
    totalNumberOfHits: number;
    totalPages: number;
    loading: boolean;
    loadNextPage: () => void;
};

const OrderList = ({
    orders,
    totalNumberOfHits,
    totalPages,
    loading,
    loadNextPage
}: Props) => {
    const { t } = useGranite();

    const [activeId, setActiveId] = useState<null | string>(null);

    return (
        <div>
            {orders.map((order) => (
                <div
                    key={order.id}
                    className={cn(
                        "tw:border-solid tw:border tw:border-grey-light tw:not-first:mt-4"
                    )}
                >
                    <OrderSummary
                        id={order.id}
                        creationDate={formatISO(order.creationDate)}
                        totalPrice={formatPrice(order.totalPrice, {
                            freeLabel: true,
                            currency: true,
                            t: t
                        })}
                    />
                    <Order
                        activeId={activeId}
                        orderId={order.id}
                        setActive={setActiveId}
                        order={order}
                    />
                </div>
            ))}
            {totalPages > 1 && (
                <Pagination
                    className={"mt-3"}
                    currentNumberOfHits={orders.length}
                    totalNumberOfHits={totalNumberOfHits}
                    hitsPerPage={CUSTOMER_ORDER_LIST_PAGE_SIZE}
                    loading={loading}
                    onLoadMore={loadNextPage}
                />
            )}
        </div>
    );
};

export default OrderList;
